import { connect } from 'react-redux';

import {
  pageState,
  withPageStateProvider,
} from 'common/libs/PageState/pageState';

import { compose } from 'redux';

import cancelBooking from '../actions/cancelBookingAction';
import fetchTransactionList from '../actions/fetchTransactionListAction';
import issueBooking from '../actions/issueBookingAction';
import BusTransactionList from '../components/BusTransactionList';
import resetFilters from '../actions/resetFiltersAction';

const mapStateToProps = (state, props) => {
  const isReservationListScreen = props.navigation.getParam(
    'isReservationList',
    false
  );
  const {
    isReservationList: isDataAreReservationList,
    startDate,
    endDate,
    agentId,
    disableFetch,
  } = state.bus.transactionList;

  // show inventories if it match with the screen (so reservation
  // list screen does not show transaction list data)
  return {
    inventories:
      Boolean(isReservationListScreen) === Boolean(isDataAreReservationList)
        ? state.bus.transactionList.inventories
        : [],
    startDate,
    endDate,
    agentId,
    disableFetch,
  };
};

const mapDispatchToProps = {
  cancelBooking,
  fetchTransactionList,
  issueBooking,
  resetFilters,
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  connectToRedux,
  withPageStateProvider(),
  pageState()
)(BusTransactionList);
